export default class Menu {

    constructor()
    {
        Menu.initializeBurgerMenu();
        Menu.initializeLang();
    }

    static initializeBurgerMenu() {
        let more_menu   = '[data-more-menu]',
            item_menu   = '[data-item-menu]',
            return_menu = '[data-return-menu]',
            nav_menu    = '[data-nav-menu]',
            burger_menu = '[data-burger-menu]';

        $( document ).on( 'click', burger_menu, function ( e ) {
            $('body').toggleClass('menuOpen');
            $(this).toggleClass('open');
        } );

        $( document ).on( 'click', more_menu, function ( e ) {
            $( item_menu ).removeClass( 'subMenuListItemChildrenActive' );
            $( this ).next( item_menu ).addClass( 'subMenuListItemChildrenActive' );
        } );

        $( document ).on( 'click', return_menu, function ( e ) {
            $( this ).parents( item_menu ).removeClass( 'subMenuListItemChildrenActive' );
        } );
    }

    static initializeLang() {
        function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for(var i=0; i<ca.length; i++)
            {
                var c = ca[i].trim();
                if (c.indexOf(name)==0) return c.substring(name.length,c.length);
            }
            return "";
        }

        let current_lang = getCookie('googtrans');
        let lang_item = '[data-lang]';
        $(document ).on('click', lang_item, function(){
            let value = $(this).html();
            $('.langItem').removeClass('active');
            $(this).parent().addClass('active');
            $('.langCurrent').html(value);
        });

    }
}